__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@trayio/app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@trayio/shared-http-client", "0.0.1", () => (Promise.all([__webpack_require__.e(707), __webpack_require__.e(635), __webpack_require__.e(789)]).then(() => (() => (__webpack_require__(82789))))));
			register("react-dom", "16.14.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(228), __webpack_require__.e(982), __webpack_require__.e(441)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(942), __webpack_require__.e(441), __webpack_require__.e(301)]).then(() => (() => (__webpack_require__(75942))))));
			register("react-redux", "7.1.3", () => (Promise.all([__webpack_require__.e(146), __webpack_require__.e(864), __webpack_require__.e(58), __webpack_require__.e(441), __webpack_require__.e(301)]).then(() => (() => (__webpack_require__(53058))))));
			register("react-router-dom", "5.1.2", () => (Promise.all([__webpack_require__.e(422), __webpack_require__.e(587), __webpack_require__.e(625), __webpack_require__.e(441), __webpack_require__.e(488)]).then(() => (() => (__webpack_require__(54625))))));
			register("react-router", "5.1.2", () => (Promise.all([__webpack_require__.e(146), __webpack_require__.e(422), __webpack_require__.e(587), __webpack_require__.e(180), __webpack_require__.e(441)]).then(() => (() => (__webpack_require__(24180))))));
			register("react", "16.14.0", () => (Promise.all([__webpack_require__.e(540), __webpack_require__.e(228)]).then(() => (() => (__webpack_require__(96540))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(146), __webpack_require__.e(606), __webpack_require__.e(833), __webpack_require__.e(472), __webpack_require__.e(441)]).then(() => (() => (__webpack_require__(54472))))));
			initExternal(68735);
			initExternal(32547);
			initExternal(83755);
			initExternal(51503);
			initExternal(88759);
			initExternal(92655);
			initExternal(73361);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};